import { Injectable } from '@angular/core';
import { getEnvironment } from '../environment/environment';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  env = getEnvironment();

  private isLoading = false;
  private isLoadingAlt = false;
  constructor(
  ) { }

  dismiss() {
    if(this.isLoading) {
      $('html, body').css('overflow', '');
      $('.loading_wrapper.init').remove();
      this.isLoading = false;
    }
  }

  loadingShow(typeLoader: 1 | 2 | 3 = this.env.loaderType, message?: string) {
    if(!this.isLoading) {
      // console.log('loading');
      let default_loader = '<div class="loads-ellipsis"><div></div><div></div><div></div><div></div></div>';
      let loader;
      switch (typeLoader) {
        case 3:
        loader = `<div class="w-full"><img src="${this.env.imgLogo}" /><br></div><span class="loader__spin3"></span>`;
        break;

        case 2:
        loader = '<div class="loadingio-spinner-dual-ball"><div class="ldio-dualball"><div></div><div></div><div></div></div></div>';
        break;

        default:
        loader = default_loader;
        break;
      }
      $('html, body').css('overflow', 'hidden');
      $('body').append(`<div class="loading_wrapper init"><div class="backdrop_loading"></div><div class="loading__content">${loader}<p>${message || this.env.loaderDefaultText}</p></div></div>`);
      this.isLoading = true;
      // setTimeout(() => {
      //   if(this.isLoading) {
      //     $('.loading_wrapper.init').remove();
      //     this.isLoading = false;
      //   }
      // }, 10000);
    }
  }

  dismissAlt() {
    if(this.isLoadingAlt) {
      $('html, body').css('overflow', '');
      $('.loading_wrapper.alt').remove();
      this.isLoadingAlt = false;
    }
  }

  loadingShowAlt(typeLoader: 1 | 2 | 3 = this.env.loaderType, message?: string) {
    if(!this.isLoading) {
      // console.log('loading');
      let default_loader = '<div class="loads-ellipsis"><div></div><div></div><div></div><div></div></div>';
      let loader;
      switch (typeLoader) {
        case 3:
        loader = '<span class="loader__spin3"></span>';
        break;

        case 2:
        loader = '<div class="loadingio-spinner-dual-ball"><div class="ldio-dualball"><div></div><div></div><div></div></div></div>';
        break;

        default:
        loader = default_loader;
        break;
      }
      $('html, body').css('overflow', 'hidden');
      $('body').append(`<div class="loading_wrapper alt"><div class="backdrop_loading"></div><div class="loading__content">${loader}<p>${message || this.env.loaderDefaultText}</p></div></div>`);
      this.isLoadingAlt = true;
      // setTimeout(() => {
      //   if(this.isLoadingAlt) {
      //     $('.loading_wrapper.alt').remove();
      //     this.isLoadingAlt = false;
      //   }
      // }, 10000);
    }
  }

  // * Push Notification
  dismissPermissionNotification() {
    const $element = $('.loading_wrapper-permission-notification');
    if ($element.length) {
      $element.remove();
    }
  }

  permissionNotification() {
    $('body').append(`<div class="loading_wrapper-permission-notification"><div class="backdrop_loading"></div><div class="loading__content"><div class="loading__content-icon"><img src="/assets/icons/notification-bell-on.svg" /></div><div class="loading__content-info"><h4>Permitir notificaciones</h4><p>Haz clic en la opción "Permitir" que se encuentra en la parte superior para recibir notificaciones.</p><img src="/assets/img/notification-alert-default.png" /><p><small>En caso de no recibir la alerta, haz click en "Aceptar" e ingresa a "Recomendaciones".</small></p><button class="btn btn-primary" onclick="dismiss()">Aceptar</button></div><script>function dismiss() { const $element = $('.loading_wrapper-permission-notification'); if ($element.length) { $element.remove(); } }</script></div></div>`);
  }
}
